<template>
	<div class="account_summary" id="account_summary" >
		<div class="account_summary_content container">
			<SectionHeader
			topText="2023 season TICKET HOLDER"
			bottomText="Plans &#38; Pricing"
			/>

			<PlanSection
			/>
<!-- :active="[option.active === true ? 'active' : '']" -->
			<div class="seatingMap">
				<SeatingChart
				@selectedSeatPlan="getSelectedSectionInfo"
				:selectedPlanType="this.planType"
				:gamePlanName="this.gamePlanName"
				:sectionName="this.selectedPlan"

				/>

				<div class="map">
					<img :src="require('@/assets/images/account/SeatingMap_2022.jpg')" alt="">
				</div>

			</div>

			<div class="pricing_section">
				<div class="priceCode_Btn">
					<button type="button"  :class=" { active: (this.planType == 'daily') }" v-on:click="getPlanInfo('daily')" name="button">Daily</button>
					<button type="button"  :class=" { active: (this.planType == 'half_red') }" v-on:click="getPlanInfo('half_red')" name="button">Half Season - Red</button>
					<button type="button"  :class=" { active: (this.planType == 'half_blue') }" v-on:click="getPlanInfo('half_blue')" name="button">Half Season - Blue</button>
				</div>
				<div class="price_distribution">
					<div class="pricing_info">
						<h2 v-if="$store.getters['dom/isMobile'] || $store.getters['dom/isTablet']"> {{this.selectedPlan ? this.selectedPlan: "Club Box Home Plate"}} </h2>
						<div class="pricing_content">

							<div class="price_data">
								<h5 class="seat_type">Diamond</h5>
								<p class="game_type">{{gameNumbers ? gameNumbers.diamond : "#"}} Games</p>
								<p class="price">${{ gamePlanPrice ? dollarFormat(gamePlanPrice.diamond) : "000.00"}}</p>
							</div>
							<div class="price_data">
								<h5 class="seat_type">Marquee</h5>
								<p class="game_type">{{gameNumbers ? gameNumbers.marquee : "#"}} Games</p>
								<p class="price">${{ gamePlanPrice ? dollarFormat(gamePlanPrice.marquee) : "000.00"}}</p>
							</div>
							<div class="price_data">
								<h5 class="seat_type">Platinum</h5>
								<p class="game_type">{{gameNumbers ? gameNumbers.platinum : "#"}} Games</p>
								<p class="price">${{ gamePlanPrice ? dollarFormat(gamePlanPrice.platinum) : "000.00"}}</p>
							</div>
							<div class="price_data">
								<h5 class="seat_type">Gold</h5>
								<p class="game_type">{{gameNumbers ? gameNumbers.gold : "#"}} Games</p>
								<p class="price">${{ gamePlanPrice ? dollarFormat(gamePlanPrice.gold) : "000.00"}}</p>
							</div>
							<div class="price_data">
								<h5 class="seat_type">Silver</h5>
								<p class="game_type">{{gameNumbers ? gameNumbers.silver : "#"}} Games</p>
								<p class="price">${{ gamePlanPrice ? dollarFormat(gamePlanPrice.silver) : "000.00"}}</p>
							</div>
							<div class="price_data">
								<h5 class="seat_type">Bronze</h5>
								<p class="game_type">{{gameNumbers ? gameNumbers.bronze : "#"}} Games</p>
								<p class="price">${{ gamePlanPrice ? dollarFormat(gamePlanPrice.bronze) : "000.00"}}</p>
							</div>

						</div>

					</div>
					<div class="pricing_total_section">
						<div class="header">
							<h2 v-if="!$store.getters['dom/isMobile'] && !$store.getters['dom/isTablet']">{{this.selectedPlan ? this.selectedPlan: "Club Box Home Plate"}}</h2>
						</div>

						<div class="total_price">
							<div class="total_info total_col">
								<p>Total</p>
								<p>${{ gamePlanPrice ? dollarFormat(gamePlanPrice.total) : "000.00"}}</p>
							</div>
							<div class="tax_info total_col">
								<p>Tax</p>
								<p>${{ gamePlanPrice ? dollarFormat(gamePlanPrice.tax) : "000.00"}}</p>
							</div>
							<div class="grand_total total_col">
								<p>Grand Total*</p>
								<p>${{ gamePlanPrice ? dollarFormat(gamePlanPrice.grandTotal) : "000.00"}}</p>
							</div>
							<div class="total_col notice">
								<p>*Price does not include $20 processing fee</p>
							</div>

						</div>
						<a v-if="this.planType == 'daily'" href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal%20Pricing_Daily_2023.pdf" target="_blank" class="dailySchedule_btn pricing_download">View 2023 Daily Plan Pricing</a>
						<a v-if="this.planType == 'half_red'" href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal%20Pricing_Red_2023.pdf" target="_blank" class="dailySchedule_btn pricing_download">View 2023 Red Plan Pricing</a>
						<a v-if="this.planType == 'half_blue'" href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal%20Pricing_Blue_2023.pdf" target="_blank" class="dailySchedule_btn pricing_download">View 2023 Blue Plan Pricing</a>

					</div>
				</div>

			</div>


		</div>
		<divider img_src="divider-3.png" author="Nico Hoerner" quote=" “Thank you Cubs fans for 162 games of energy, love, and support! You guys deserve the best, and I can't wait to build on our positives from this year towards that.” "/>

	</div>
</template>
<!-- left: 8px; width: calc(100% - 8px);  -->
<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
import SectionHeader from "@/components/SectionHeader";
import divider from "@/components/divider";
import  SeatingChart from "./SeatingChart";
import PlanSection from "./PlanSection";
import scheduleData from "@/data/scheduleData";
import planPricing from "@/data/planPricing";
import scheduleGameCount from "@/data/scheduleGameCount";

export default {
	name: "Account",
	components: { SectionHeader, divider,  SeatingChart, PlanSection },
	data() {
		return {
			gameDate: null,
			seatType: null,
			gamePlanPrice:null,
			gameNumbers:  null,
			activeBtn: false,
			selectedPlan: "",
			planType: "",
			gamePlanName: [],
			seatingPlan: [
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
				{
					color: "#2E3192",
					seat: "Bullpen Box Front Row"
				},
			],
		};
	},

	mounted() {
		setTimeout(() => {
			this.planType = "daily";
			this.selectedPlan = "Club Box Home Plate";
			this.getPlanInfo(this.planType);
			this.getPricingInfo();
		}, 5000);
	},

	methods:{
		getSelectedSectionInfo({sectionName}){
			//console.log(sectionName);
			this.selectedPlan = sectionName;
			this.getPricingInfo();
		},
		dollarFormat(total) {
			let newTotal = Number(total.replace(/[$,]/g, ""))
			.toFixed(2)
			.toString()
			.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			return newTotal;
		},
		getPlanInfo(planName){
			this.planType = planName;
			let gamePrice = planPricing[this.planType][0];
			this.gamePlanName = Object.keys(gamePrice);
			// console.log(this.gamePlanName);
			this.getPricingInfo();
			// check if priceinfo has the same section name if not get the first one
			// this.activeBtn = true;


		},
		getPricingInfo(){

			this.gameNumbers = scheduleGameCount[this.planType][0];

			let planName = this.selectedPlan.replace(/ /g, '_');

			let gamePrice = planPricing[this.planType][0];

			if (!(planName in gamePrice)){
				 planName = Object.keys(gamePrice)[0];
				 this.selectedPlan = planName.replace(/_/g, ' ');
				 this.gamePlanPrice = gamePrice[planName][0];
			}
			else{
				this.gamePlanPrice = gamePrice[planName][0];
			}



		}
	},

};
</script>

<style lang="scss" scoped>
.account_summary {
	background-image: url("~images/bgImage.jpg");
	background-size: cover;
	@include media-breakpoint-down(sm) {
		background-image: url("~images/bgImage_mobile.jpg");
	}
	&_content {
		align-items: center;
		z-index: 1;
		height: 100%;
		padding: 150px 100px 100px 120px;
		@include media-breakpoint-down(sm) {
			padding: 150px 30px 100px 30px;
		}
		@include media-breakpoint-only(md) {
			padding: 150px 30px 100px 30px;
		}
		@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
			padding: 150px 30px 100px 30px;
		}
		.btn-lg {
			font-size: 34px !important;
			@include media-breakpoint-down(sm) {
				font-size: 20px !important;
			}
			padding: 0.3em 3em 0.2em !important;
		}
		.footnote {
			font-size: 13px;
			margin-top: 40px;
			@include media-breakpoint-down(sm) {
				margin-top: 20px;
			}
		}


		h5{
			font-family: 'Verlag';
			font-style: normal;
			font-weight: 450;
			font-size: 16px;
			line-height: 23px;
			text-transform: uppercase;
			color: #474747;

		}
		h2{
			font-family: 'Verlag Condensed Bold';
			font-style: normal;
			font-weight: 400;
			font-size: 40px;
			line-height: 100%;
			text-transform: uppercase;
			color: #0E3386;
			margin-bottom: 15px;
			@include media-breakpoint-down(sm) {
				font-size: 30px;
				margin: 15px 0px;
			}

		}
		p{
			font-family: 'Verlag Light';
			font-style: normal;
			font-weight: 325;
			font-size: 16px;
			line-height: 23px;
			color: #474747;
		}
		.seatingMap{
			display:flex;
			flex-direction: row;
			justify-content: space-between;
			background-color: white;
			box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
			padding:30px;
			margin: 20px 0px;
			img{
				// width: 445px;
				// height: auto;
				margin: 0 auto;
				display: block;
				height: 480.17px;
				width:auto;
				@include media-breakpoint-down(sm) {
					height: 272.17px;
					width:auto;
					margin: 0 auto;
					display: block;
				}
				@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
					height: 372.17px;
					width:auto;
				}
			}
			@include media-breakpoint-down(sm) {
				padding:10px;
				flex-direction: column-reverse;
			}
			@include media-breakpoint-only(md) {
				padding:10px;
				flex-direction: column-reverse;
			}
			@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
				padding:10px;
			}
			@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
				padding:10px;
			}

		}
		.pricing_section{
			display:flex;
			gap:30px;
			@media (min-width: 999px) and (max-width: 1200px) {
			}
			padding-top: 10px;
			@include media-breakpoint-down(sm) {
				flex-direction:column;
			}

			.priceCode_Btn{
				display:flex;
				flex-direction:column;
				@include media-breakpoint-down(sm) {
					flex-direction:row;
					justify-content: space-between;
				}
				button{
					background: #FFFFFF;
					font-family: 'Verlag Condensed Bold';
					font-style: normal;
					font-weight: 400;
					font-size: 18px;
					line-height: 100%;
					border:none;
					text-transform: uppercase;
					color: #0B2255;
					width:200px;
					box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
					margin-bottom:15px;
					padding: 15px 5px;
					@include media-breakpoint-down(sm) {
						font-size: 14px;
						margin: 5px;
					}
					&.active{
						background: #0B2255;
						color:white;
					}
					&:hover{
						background: #0B2255;
						color:white;
					}
				}
			}
			.price_distribution{
				display:flex;
				background-color: white;
				box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
				width:100%;
				margin-bottom:10px;
				padding: 22px;
				@include media-breakpoint-down(sm) {
					flex-direction:column;
				}
				@include media-breakpoint-only(md) {
					flex-direction:column;
				}
				// @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
				// 	// flex-direction:column;
				// }
			}
			.header{
				flex: 1 2 0;

				@media (min-width: 999px) and (max-width: 1200px) {

					h2{
						font-size: 32px;
					}

				}
				@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
					h2{
						font-size: 22px;
					}
				}
			}

			.pricing_info{
				flex: 1 2 0;
				@include media-breakpoint-down(sm) {
					padding: 10px 0px;
				}
				@media (min-width: 999px) and (max-width: 1200px) {
					padding: 0px 20px;
					flex: 1 2 0;
				}
				.price_data{
					display:flex;
					justify-content: space-between;
					@media (min-width: 999px) and (max-width: 1200px) {

					}
					.seat_type{
						flex: 2 1 0;
						@media (min-width: 999px) and (max-width: 1200px) {
							font-size:12px;
						}
					}
					.game_type{
						flex: 2 1 0;
						@media (min-width: 999px) and (max-width: 1200px) {
							font-size:12px;
						}

					}
					.price{
						flex: 1 1 0;
						@media (min-width: 999px) and (max-width: 1200px) {
							font-size:12px;
							// padding-left: 15px;
						}
					}
				}
			}
			.pricing_total_section{
				flex: 1 1 0;
				@media (min-width: 999px) and (max-width: 1200px) {

				}
				.total_col{
					display:flex;
					justify-content: space-between;
				}
				.notice{
					p
					{
						font-size:14px;
						text-transform: unset;
						margin-top:5px;
						@media (min-width: 999px) and (max-width: 1200px) {
							font-size:8px;
						}
						@include media-breakpoint-down(sm) {
							font-size:12px;
						}
					}
				}
				a{
					font-family: 'Verlag Book';
					font-style: normal;
					font-weight: 325;
					font-size: 20px;
					line-height: 24px;
					text-decoration:none;
					background: #0E3386;
					border-radius: 55px;
					padding: 8px 50px;
					display: flex;
					margin-bottom:15px;
					justify-content: center;
					align-items: center;
					color:white !important;
					@include media-breakpoint-down(sm) {
						font-size: 14px;
						padding: 8px 20px;
					}
					@include media-breakpoint-only(md) {
						font-size: 13px;
						padding: 5px 20px;
					}
					@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
						font-size: 14px;
						padding: 6px 20px;
					}

				}
				p{
					@media (min-width: 999px) and (max-width: 1200px) {
						font-size:12px;
					}

				}
				.grand_total{
					color: #FFFFFF;
					background: #CC3433;
					padding: 8px 10px;
					p{
						font-family: 'Verlag Condensed Light';
						font-style: normal;
						font-weight: 325;
						font-size: 30px;
						line-height: 90%;
						color:white;
						margin-bottom:0px;
						@media (min-width: 999px) and (max-width: 1200px) {
							font-size: 16px;

						}
						@include media-breakpoint-down(sm) {
							font-size: 24px;
						}
					}

				}
			}
		}
	}
}
</style>
